import './inProgress.css';
import * as React from 'react'
import {Component} from "react";


export class Something extends Component {
    render() {
        return(
            <div className={'in-progress'}>
                <div className={'in-progress-container'}>
                    <p>Something</p>
                </div>
            </div>
        )
    }
}